import { RouteObject } from 'react-router';
import { lazy } from 'react';

// project imports
import { AppModule, Routes } from 'utils/constants';
import MainLayout from 'components/layout/MainLayout/MainLayout';
import Loadable from 'components/loading/Loadable';
import GDSList from 'views/modules/Eai/DeliveryPoints/DeliveryPointDetail/Gds/GdsList';
import DeviceCharacteristicGroupWizard from 'views/modules/Eai/Devices/DeviceDetail/Characteristics/GroupWizard/DeviceCharacteristicGroupWizard';
import BalanceGroupList from 'views/modules/Eai/BalanceGroup/BalanceGroupList';

// routing users
const UserList = Loadable(
  lazy(() => import('views/modules/Eai/Users/UserList'))
);
const UserDetail = Loadable(
  lazy(() => import('views/modules/Eai/Users/UserDetail/UserDetail'))
);
const UserWizard = Loadable(
  lazy(() => import('views/modules/Eai/Users/UserWizard'))
);

// routing subjects
const SubjectList = Loadable(
  lazy(() => import('views/modules/Eai/Subjects/SubjectList'))
);
const SubjectDetail = Loadable(
  lazy(() => import('views/modules/Eai/Subjects/SubjectDetail'))
);
const SubjectWizard = Loadable(
  lazy(() => import('views/modules/Eai/Subjects/SubjectWizard'))
);
const SubjectAccountWizard = Loadable(
  lazy(
    () =>
      import('views/modules/Eai/Subjects/SubjectDetail/SubjectAccountWizard')
  )
);

// routing balance groups
const BalanceGroupDetail = Loadable(
  lazy(
    () =>
      import(
        'views/modules/Eai/BalanceGroup/BalanceGroupDetail/BalanceGroupDetail'
      )
  )
);

// routing delivery points
const DeliveryPointList = Loadable(
  lazy(() => import('views/modules/Eai/DeliveryPoints/DeliveryPointList'))
);
const DeliveryPointDetail = Loadable(
  lazy(
    () =>
      import(
        'views/modules/Eai/DeliveryPoints/DeliveryPointDetail/DeliveryPointDetail'
      )
  )
);
const DeliveryPointWizard = Loadable(
  lazy(() => import('views/modules/Eai/DeliveryPoints/DeliveryPointWizard'))
);

// routing devices
const DeviceList = Loadable(
  lazy(() => import('views/modules/Eai/Devices/DeviceList'))
);
const DeviceDetail = Loadable(
  lazy(() => import('views/modules/Eai/Devices/DeviceDetail/DeviceDetail'))
);
const DeviceWizard = Loadable(
  lazy(() => import('views/modules/Eai/Devices/DeviceWizard'))
);

// routing delivery contracts
const DeliveryContractList = Loadable(
  lazy(() => import('views/modules/Eai/DeliveryContracts/DeliveryContractList'))
);
const DeliveryContractDetail = Loadable(
  lazy(
    () => import('views/modules/Eai/DeliveryContracts/DeliveryContractDetail')
  )
);
const DeliveryContractWizard = Loadable(
  lazy(
    () => import('views/modules/Eai/DeliveryContracts/DeliveryContractWizard')
  )
);

// ==============================|| EAI ROUTES ||============================== //

const routesEai: RouteObject = {
  path: `${Routes.BASE_PATH}:tenant`,
  element: <MainLayout module={AppModule.EAI} />,
  children: [
    {
      path: Routes.EAI.USER_LIST_PATH,
      element: <UserList />
    },
    {
      path: Routes.EAI.USER_DETAIL_PATH,
      element: <UserDetail />
    },
    {
      path: Routes.EAI.USER_DETAIL_ASSIGNMENT_PATH,
      element: <UserDetail />
    },
    {
      path: Routes.EAI.USER_CREATE_PATH,
      element: <UserWizard />
    },
    {
      path: Routes.EAI.SUBJECT_LIST_PATH,
      element: <SubjectList />
    },
    {
      path: Routes.EAI.SUBJECT_DETAIL_PATH,
      element: <SubjectDetail />
    },
    {
      path: Routes.EAI.SUBJECT_CREATE_PATH,
      element: <SubjectWizard />
    },
    {
      path: Routes.EAI.SUBJECT_ACCOUNT_CREATE_PATH,
      element: <SubjectAccountWizard />
    },
    {
      path: Routes.EAI.BALANCE_GROUP_LIST_PATH,
      element: <BalanceGroupList />
    },
    {
      path: Routes.EAI.BALANCE_GROUP_DETAIL_PATH,
      element: <BalanceGroupDetail />
    },
    {
      path: Routes.EAI.DELIVERY_POINTS_LIST_PATH,
      element: <DeliveryPointList />
    },
    {
      path: Routes.EAI.DELIVERY_POINTS_DETAIL_PATH,
      element: <DeliveryPointDetail />
    },
    {
      path: Routes.EAI.DELIVERY_POINTS_CREATE_PATH,
      element: <DeliveryPointWizard />
    },
    {
      path: Routes.EAI.DELIVERY_POINT_GDS_LIST_PATH,
      element: <GDSList />
    },
    {
      path: Routes.EAI.DELIVERY_POINTS_DETAIL_PATH_WITH_GDS_ID,
      element: <DeliveryPointDetail />
    },
    {
      path: Routes.EAI.DEVICES_LIST_PATH,
      element: <DeviceList />
    },
    {
      path: Routes.EAI.DEVICES_DETAIL_PATH,
      element: <DeviceDetail />
    },
    {
      path: Routes.EAI.DEVICES_CHARACTERISTIC_GROUP_DETAIL,
      element: <DeviceDetail />
    },
    {
      path: Routes.EAI.DEVICES_CREATE_PATH,
      element: <DeviceWizard />
    },
    {
      path: Routes.EAI.DEVICES_CHARACTERISTIC_GROUP_CREATE_PATH,
      element: <DeviceCharacteristicGroupWizard />
    },
    {
      path: Routes.EAI.DELIVERY_CONTRACTS_LIST_PATH,
      element: <DeliveryContractList />
    },
    {
      path: Routes.EAI.DELIVERY_CONTRACTS_DETAIL_PATH,
      element: <DeliveryContractDetail />
    },
    {
      path: Routes.EAI.DELIVERY_CONTRACTS_CREATE_PATH,
      element: <DeliveryContractWizard />
    }
  ]
};

export default routesEai;
